<div class="cardModal">
    <div class="cardTitle">
        <h3>{{ 'dashboard.visuals.editModal.title' | translate }}</h3>
    </div>
    <div class="cardContentStretched">
        <div class="widget-edit-modal-content">
            <h3>{{ widgetTitle() | translate }}</h3>
            <div [innerHtml]="widgetDescription()"></div>
            @if (hasMultipleSizes() && widget()) {
                <app-visuals-dashboard-size-picker
                    [availableSizes]="widget()?.availableSizes || []"
                    [initialSelectedSize]="widget()?.selectedSize ?? null"
                    (emitSelectedSize)="onSizeSelected($event)"
                ></app-visuals-dashboard-size-picker>
            }
            @if (showPeriodPicker() && widget()) {
                <app-visuals-dashboard-period-picker
                    [selectedOptionValue]="selectedPeriodValue()"
                    (periodChange)="onPeriodChange($event)"
                ></app-visuals-dashboard-period-picker>
            }
            @let widgetData = widget();
            @if (showDistributionSettings() && widgetData) {
                <app-visuals-dashboard-distribution-settings-picker
                    [widget]="widgetData"
                    (distributorSettingsChanged)="onDistributorSettingsChange($event)"
                ></app-visuals-dashboard-distribution-settings-picker>
            }
        </div>
    </div>
    <div class="cardFooter">
        <div class="buttonArea centered">
            <button
                class="button primary"
                (click)="saveChanges()"
                type="button"
                id="confirmVisualDashboardItemEditModal"
                [title]="'dashboard.visuals.editModal.saveButton' | translate"
            >
                {{ 'dashboard.visuals.editModal.saveButton' | translate }}
            </button>
            <button
                class="button"
                (click)="closeModal()"
                type="button"
                id="closeVisualDashboardItemEditModal"
                title="{{ 'generalKeywords.close' | translate }}"
            >
                {{ 'generalKeywords.close' | translate }}
            </button>
        </div>
    </div>
</div>
